import CalculetteCommon, {
    COUT_CARBU_LITRE,
    COUT_PLAN_MOIS,
    JOUR_TRAV_AN,
    NB_LITRE_KM,
    PRIX_LICENCE,
} from './calculette-common';

const NB_HEURES_PLANIFICATION = 2;
const QTT_PAPIER_INTERVENTION = 1;
const COUT_IMPRESSION_PAPIER = 0.25;

const Economie = {
    init() {
        const nbTech = $('#calc-eco-nb-tech');
        const nbInterventionTech = $('#calc-eco-int-tech');
        const nbKmIntervention = $('#calc-eco-nb-km');
        const nbPlanificateur = $('#calc-eco-nb-plan');
        const ctaHubspotEconomy = $('#cta-hubspot-economy > a');
        const simulationHubspotBlock = $('.js-simulation-hubspot-related');
        const economieForm = $('.js-form-economie');

        if (!!economieForm.length) {
            CalculetteCommon.alterSubmitButtonAppearance(economieForm);
            $(window).on(
                'resize', function () {
                    CalculetteCommon.alterSubmitButtonAppearance(economieForm);
                }
            );
            CalculetteCommon.handleFocusInput(economieForm);

            economieForm.on(
                'submit', function (e) {
                    e.preventDefault();
                    Economie.submitForm(nbTech, nbInterventionTech, nbKmIntervention, nbPlanificateur, economieForm, simulationHubspotBlock);
                }
            );

            if (ctaHubspotEconomy.length) {
                ctaHubspotEconomy.on(
                    'click', function (e) {
                        e.preventDefault();
                        Economie.collectHubspotEconomyVariables($(this), nbTech, nbInterventionTech, nbKmIntervention, nbPlanificateur);
                    }
                );
            }

            nbTech.on(
                'input', function () {
                    CalculetteCommon.validateInputOnChange($(this), economieForm);
                }
            );

            nbInterventionTech.on(
                'input', function () {
                    CalculetteCommon.validateInputOnChange($(this), economieForm);
                }
            );

            nbKmIntervention.on(
                'input', function () {
                    CalculetteCommon.validateInputOnChange($(this), economieForm);
                }
            );

            nbPlanificateur.on(
                'input', function () {
                    CalculetteCommon.validateInputOnChange($(this), economieForm);
                }
            );
        }
    },

    submitForm(nbTech, nbInterventionTech, nbKmIntervention, nbPlanificateur, form, simulationHubspotBlock) {
        form.data('submit', 'submitted');
        const formStatusInputs = [
            CalculetteCommon.validateInputOnSubmit(nbTech),
            CalculetteCommon.validateInputOnSubmit(nbInterventionTech),
            CalculetteCommon.validateInputOnSubmit(nbKmIntervention),
            CalculetteCommon.validateInputOnSubmit(nbPlanificateur),
        ];
        if (formStatusInputs.includes(false)) {
            form.data('valid', '');
        } else {
            form.data('valid', 'valid');
        }

        if (form.data('valid') === 'valid') {
            const simulatorSection = $('#simulation-economie');
            const resultEltWrapper = $('.economie .simulation__result .valid');
            const resultFirstElt = resultEltWrapper.find('.first-result');
            const resultSecondElt = resultEltWrapper.find('.second-result');
            const resultZero = $('.economie .simulation__result .zero');
            const eco5percent = Economie.calculateEconomy(nbTech, nbInterventionTech, nbKmIntervention, nbPlanificateur, .05, .2);
            const eco15percent = Economie.calculateEconomy(nbTech, nbInterventionTech, nbKmIntervention, nbPlanificateur, .15, .4);

            CalculetteCommon.displayValidResult(eco5percent, eco15percent, resultEltWrapper, resultFirstElt, resultSecondElt, resultZero, simulatorSection);
            simulationHubspotBlock.css('display', 'block');
        } else {
            simulationHubspotBlock.css('display', 'none');
        }
    },

    collectHubspotEconomyVariables(ctaHubspot, nbTech, nbInterventionTech, nbKmIntervention, nbPlanificateur) {
        const urlParams = new URLSearchParams();
        const hubspotUrl = ctaHubspot.attr('href');

        urlParams.set('nombre_de_technciens', nbTech.val());
        urlParams.set('nombre_d_interventions_par_jour_par_technicien', nbInterventionTech.val());
        urlParams.set('nombre_de_kilometres_quotidien_par_technicien', nbKmIntervention.val());
        urlParams.set('nombre_de_planificateur', nbPlanificateur.val());
        urlParams.set('previsionnel_economie', CalculetteCommon.simulationResultText);

        if (hubspotUrl.includes('?')) {
            location.href = hubspotUrl + '&' + urlParams.toString();
        } else {
            location.href = hubspotUrl + '?' + urlParams.toString();
        }
    },

    calculateEconomy(nbTechnicien, nbIntTech, nbKmInt, nbPlan, shadow, paramPourcentage) {
        const nbTech = parseFloat(nbTechnicien.val());
        const nbInterventionTech = parseFloat(nbIntTech.val());
        const nbKmIntervention = parseFloat(nbKmInt.val());
        const nbPlanificateur = parseFloat(nbPlan.val());

        //Constantes intermediaires
        const nbKmAn = nbKmIntervention * nbInterventionTech * nbTech * JOUR_TRAV_AN;
        const depCarbuAn = nbKmAn * NB_LITRE_KM * COUT_CARBU_LITRE;
        const nbKmAnShadow = nbKmAn - (nbKmAn * shadow);
        const depCarbuAnShadow = depCarbuAn - (nbKmAnShadow * NB_LITRE_KM * COUT_CARBU_LITRE);
        const coutPlan = (nbPlanificateur * COUT_PLAN_MOIS * 12) * NB_HEURES_PLANIFICATION;
        const coutPapierAn = QTT_PAPIER_INTERVENTION * nbInterventionTech * nbTech * JOUR_TRAV_AN * COUT_IMPRESSION_PAPIER;
        const coutLicenceAn = (nbTech + nbPlanificateur) * PRIX_LICENCE * 12;

        //résultat final
        const economie = (depCarbuAnShadow + (coutPlan * paramPourcentage) + coutPapierAn) - coutLicenceAn;
        return Math.round(economie);
    },
};

export default Economie;
